import http from '../httpService';

export function createProposalForm(payload) {
  return http.post('/proposal-forms', payload);
}

export function editProposalForm(id,data) {
  return http.put(`/proposal-forms/${id}`,data);
}
export function getProposalForm(cycleId) {
  return http.get(`proposal-forms?cycleId.equals=${cycleId}`);
}
export function getProposalOverallRiskAssessmentLevels() {
  return http.get(`proposal-overall-risk-assessment-levels`);
}